import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {OldMapComponent} from '@components/old-map/old-map.component';
import {
   Field,
  Season,

} from '@6grain/masofa-monolith-api-client/crop-monitoring';

import {FieldCropsColorPipe} from '@app/utils/pipes/field-crops-color-pipe';
import {IPolygonColor} from '@components/request-map/request-map.component2';
import {Crop} from '@6grain/masofa-monolith-api-client/dictionaries';
import {PassportManagerService} from '@app/pages/electronic-field-map/pages/fields/passport/passport-manager.service';

@Component({
  selector: 'app-passport-general-map',
  standalone: true,
  templateUrl: './passport-general-map.html',
  imports: [
    OldMapComponent
  ],
  styleUrl: './passport-general-map.scss'
})
export class PassportGeneralMap implements OnChanges{

  fieldCropsColor = inject(FieldCropsColorPipe);
  passportManager = inject(PassportManagerService);
  afterLoadPolygonJson = false;


  @Input({required:true}) activeSeasons: Season[] | undefined = [];
  @Input({required:true}) activeCrops: Crop[] | undefined = [];
  @Input({required:true}) field?: Field | null | undefined;
  @Input() multiPolygonJson: IPolygonColor[] = [];
  @Output() multiPolygonJsonChange = new EventEmitter<IPolygonColor[]>();

  private emitMultiPolygonJsonChange(): void {
    queueMicrotask(() => {
      this.multiPolygonJsonChange.emit(this.multiPolygonJson);
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['activeSeasons'] || changes['activeCrops']) &&
      this.activeSeasons && this.activeCrops)  {
      //@ts-ignore
      const seasonsPolygonsJson: IPolygonColor[] =
        (this.activeSeasons as Season[]).map(value => {
          const color = this.fieldCropsColor.transform(this.activeCrops?.find(crop => crop.id === value.cropId) as Crop);
          return {
            polygon: value?.polygonJson,
            color: color || 'rgba(119, 255, 15, 0.34)'
          }
        });

      this.afterLoadPolygonJson = true;
      if (seasonsPolygonsJson.length > 0) {
        this.multiPolygonJson = seasonsPolygonsJson.filter(item => item.polygon != null);
      }
      this.emitMultiPolygonJsonChange();
    } else {
      this.afterLoadPolygonJson = true;
    }

    if (changes['field'] && this.field && this.field.polygonJson) {
      if (this.activeSeasons && this.activeCrops &&
        this.activeSeasons.length > 0 && this.activeCrops.length > 0
      )  {
        return
      }

      this.multiPolygonJson = [{
        polygon: this.field.polygonJson as string,
        color: 'rgba(119, 255, 15, 0.34)'
      }];
      this.emitMultiPolygonJsonChange();
    }
  }
}
